"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import { useVotingModalState } from "@/components/voting/useVotingModalState";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import DropCurationButton from "@/components/waves/drops/DropCurationButton";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuCopyLink from "@/components/waves/drops/WaveDropMobileMenuCopyLink";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { DropContentPresentation } from "@/components/waves/drops/dropContentPresentation";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { WaveLeaderboardDropAuthorAvatar } from "./header/WaveLeaderboardDropAuthor";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winningThreshold?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation;
}
const isClickFromCardDom = (event: React.MouseEvent<HTMLDivElement>): boolean => {
  return event.currentTarget.contains(event.target as Node);
};
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(87);
  const {
    drop,
    onDropClick,
    winningThreshold,
    isVotingClosed: t1,
    isVotingControlsLocked: t2,
    contentPresentation: t3
  } = t0;
  const isVotingClosed = t1 === undefined ? false : t1;
  const isVotingControlsLocked = t2 === undefined ? false : t2;
  const contentPresentation = t3 === undefined ? "default" : t3;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const canShowVotingAction = canShowVote && !isVotingActionLocked;
  const {
    isOpen: isVoteModalOpen,
    open: openVoteModal,
    close: closeVoteModal
  } = useVotingModalState(isVotingActionLocked);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  const suppressNextClickRef = React.useRef(false);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      suppressNextClickRef.current = true;
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const handleInteractionStart = t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      if (!suppressNextClickRef.current) {
        return;
      }
      suppressNextClickRef.current = false;
      event.preventDefault();
      event.stopPropagation();
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const handleClickCapture = t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      suppressNextClickRef.current = false;
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const clearPendingLongPressClick = t6;
  let t7;
  if ($[3] !== hasTouchScreen) {
    t7 = {
      hasTouchScreen,
      onInteractionStart: handleInteractionStart,
      preventDefault: false
    };
    $[3] = hasTouchScreen;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t7);
  let t8;
  if ($[5] !== setIsActive) {
    t8 = nextIsActive => {
      if (!nextIsActive) {
        suppressNextClickRef.current = false;
      }
      setIsActive(nextIsActive);
    };
    $[5] = setIsActive;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const handleMobileMenuOpenChange = t8;
  let t9;
  if ($[7] !== handleMobileMenuOpenChange) {
    t9 = () => {
      handleMobileMenuOpenChange(false);
    };
    $[7] = handleMobileMenuOpenChange;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const handleMobileMenuClose = t9;
  const getBorderClasses = _temp;
  let t10;
  if ($[9] !== openVoteModal) {
    t10 = () => {
      openVoteModal();
    };
    $[9] = openVoteModal;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const handleVoteButtonClick = t10;
  let t11;
  if ($[11] !== drop || $[12] !== isMobileScreen || $[13] !== onDropClick) {
    t11 = event_0 => {
      if (!isClickFromCardDom(event_0)) {
        return;
      }
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[11] = drop;
    $[12] = isMobileScreen;
    $[13] = onDropClick;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const handleClick = t11;
  let t12;
  if ($[15] !== drop) {
    t12 = <div className="tw-flex-shrink-0 tw-self-start"><WaveLeaderboardDropAuthorAvatar drop={drop} /></div>;
    $[15] = drop;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== drop || $[18] !== winningThreshold) {
    t13 = <WaveLeaderboardDropHeader drop={drop} showAvatar={false} winningThreshold={winningThreshold} />;
    $[17] = drop;
    $[18] = winningThreshold;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== drop) {
    t14 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[20] = drop;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== canDelete || $[23] !== drop) {
    t15 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[22] = canDelete;
    $[23] = drop;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15) {
    t16 = <div className="tw-hidden tw-h-8 lg:tw-block">{t15}</div>;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t14 || $[28] !== t16) {
    t17 = <div className="tw-flex tw-items-center">{t14}{t16}</div>;
    $[27] = t14;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t13 || $[31] !== t17) {
    t18 = <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">{t13}{t17}</div>;
    $[30] = t13;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== contentPresentation || $[34] !== drop) {
    t19 = <WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} contentPresentation={contentPresentation} />;
    $[33] = contentPresentation;
    $[34] = drop;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== drop || $[37] !== isVotingClosed || $[38] !== winningThreshold) {
    t20 = <WaveLeaderboardDropRaters drop={drop} winningThreshold={winningThreshold} isVotingClosed={isVotingClosed} />;
    $[36] = drop;
    $[37] = isVotingClosed;
    $[38] = winningThreshold;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== drop) {
    t21 = <WaveLeaderboardDropFooter drop={drop} />;
    $[40] = drop;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t20 || $[43] !== t21) {
    t22 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">{t20}{t21}</div>;
    $[42] = t20;
    $[43] = t21;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  const t23 = drop.context_profile_context?.curatable ?? false;
  const t24 = drop.context_profile_context?.curated ?? false;
  let t25;
  if ($[45] !== drop.id || $[46] !== drop.wave.id || $[47] !== t23 || $[48] !== t24) {
    t25 = <DropCurationButton waveId={drop.wave.id} dropId={drop.id} isCuratable={t23} isCurated={t24} />;
    $[45] = drop.id;
    $[46] = drop.wave.id;
    $[47] = t23;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== canShowVotingAction || $[51] !== drop || $[52] !== handleVoteButtonClick) {
    t26 = canShowVotingAction && <VotingModalButton drop={drop} onClick={handleVoteButtonClick} className="tw-font-semibold" />;
    $[50] = canShowVotingAction;
    $[51] = drop;
    $[52] = handleVoteButtonClick;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = <div className="tw-flex tw-w-full tw-items-center tw-justify-end tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp2}>{t25}{t26}</div>;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t22 || $[58] !== t27) {
    t28 = <div className="tw-mt-3 tw-flex tw-w-full tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0">{t22}{t27}</div>;
    $[57] = t22;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t18 || $[61] !== t19 || $[62] !== t28) {
    t29 = <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">{t18}{t19}{t28}</div>;
    $[60] = t18;
    $[61] = t19;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t12 || $[65] !== t29) {
    t30 = <div className="tw-flex tw-gap-x-3">{t12}{t29}</div>;
    $[64] = t12;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t30 || $[68] !== touchHandlers) {
    t31 = <div className={getBorderClasses()} {...touchHandlers}>{t30}</div>;
    $[67] = t30;
    $[68] = touchHandlers;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] !== closeVoteModal || $[71] !== drop || $[72] !== isMobileScreen || $[73] !== isVoteModalOpen) {
    t32 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVoteModalOpen} onClose={closeVoteModal} /> : <VotingModal drop={drop} isOpen={isVoteModalOpen} onClose={closeVoteModal} />;
    $[70] = closeVoteModal;
    $[71] = drop;
    $[72] = isMobileScreen;
    $[73] = isVoteModalOpen;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== canDelete || $[76] !== drop || $[77] !== handleMobileMenuClose || $[78] !== handleMobileMenuOpenChange || $[79] !== hasTouchScreen || $[80] !== isActive) {
    t33 = hasTouchScreen && createPortal(<div onPointerDownCapture={clearPendingLongPressClick} onTouchStartCapture={clearPendingLongPressClick}><CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={handleMobileMenuOpenChange}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={handleMobileMenuClose} /><WaveDropMobileMenuCopyLink drop={drop} onCopy={handleMobileMenuClose} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={handleMobileMenuClose} />}</div></CommonDropdownItemsMobileWrapper></div>, document.body);
    $[75] = canDelete;
    $[76] = drop;
    $[77] = handleMobileMenuClose;
    $[78] = handleMobileMenuOpenChange;
    $[79] = hasTouchScreen;
    $[80] = isActive;
    $[81] = t33;
  } else {
    t33 = $[81];
  }
  let t34;
  if ($[82] !== handleClick || $[83] !== t31 || $[84] !== t32 || $[85] !== t33) {
    t34 = <div onClickCapture={handleClickCapture} onClick={handleClick} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t31}{t32}{t33}</div>;
    $[82] = handleClick;
    $[83] = t31;
    $[84] = t32;
    $[85] = t33;
    $[86] = t34;
  } else {
    t34 = $[86];
  }
  return t34;
};
function _temp() {
  return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
}
function _temp2(e) {
  return e.stopPropagation();
}